export default __webpack_public_path__ + "static/media/Nunito-ExtraBoldItalic.d4e2dce0.woff";